module.exports = __webpack_public_path__ + "static/media/eu-footer.3b1714fd.png";